import { Typography, useTheme, Box, Grid } from '@mui/material';

// Components
import { IContributeDetailCompany } from 'src/utils/typings/response/contribute';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';

const OtherNamesCompany = ({ dataContribution }: { dataContribution: IContributeDetailCompany }) => {
  const theme = useTheme();

  return (
    <Box
      width="100%"
      padding={2}
      border={`1px dashed ${theme.palette.divider}`}
      borderRadius={theme.shape.borderRadius / 2}
    >
      <Grid container rowGap={2}>
        {getArrayDefault(
          dataContribution?.contribution_other_names_company_profile?.map((item, index) => (
            <Grid key={`contribute-email-company-${index}`} item xs={6}>
              <Typography align="left" variant="caption2" color="text.secondary" component="p">
                Other Name {index + 1}
              </Typography>
              <Box mt={1} />
              <Typography align="left" variant="body2" color="text.primary">
                {renderTextOrDefault(item?.other_name || '')}
              </Typography>
            </Grid>
          )),
        )}
      </Grid>
    </Box>
  );
};

export default OtherNamesCompany;
